import type { FC } from "react";
import { useSelector } from "react-redux";
import { HtsAirCfarOffersSelectors } from "@b2bportal/core-flights-cfar-offers";
import {
  IconNameEnum,
  useCfarStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsCfarOffersComponents } from "@b2bportal/core-types";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { InfoBanner, InfoBannerSeverity } from "@tenant/ui";

const COMPONENT_KEY = CoreFlightsCfarOffersComponents.CfarReturnFilterBanner;

export const CfarReturnFilterBanner: FC = () => {
  const [_block, cn] = useModuleBEM(
    useCfarStyles(COMPONENT_KEY),
    COMPONENT_KEY
  );

  const { locale } = useI18nContext();
  const isOutboundSyntheticSelected = useSelector(
    HtsAirCfarOffersSelectors.selectRoundTripOutboundSyntheticSelected
  );
  const coveragePercentage = useSelector(
    HtsAirCfarOffersSelectors.selectRoundTripOutboundSyntheticCoveragePercentage
  );

  if (!isOutboundSyntheticSelected || coveragePercentage == null) return null;

  const formattedCoveragePercentage = new Intl.NumberFormat(locale, {
    style: "percent",
    maximumFractionDigits: 0,
  }).format(coveragePercentage / 100);

  return (
    <div className={_block}>
      <InfoBanner
        severity={InfoBannerSeverity.INFO}
        icon={IconNameEnum.infoFilled}
        className={cn("banner")}
      >
        <Trans
          i18nKey="core-flights-cfar.returnFilterBanner"
          values={{ coveragePercentage: formattedCoveragePercentage }}
          components={[<strong />]}
        />
      </InfoBanner>
    </div>
  );
};
